{
  "sourceWidth": 169,
  "sourceHeight": 141,
  "heightMeters": 11.733333333333333,
  "originY": 0.94,
  "drawOffsetYMeters": 0.9333333333333333,
  "outline": [
    [7, 85],
    [14, 71],
    [16, 69],
    [28, 58],
    [30, 57],
    [33, 56],
    [58, 52],
    [65, 52],
    [86, 56],
    [110, 61],
    [115, 63],
    [117, 64],
    [120, 66],
    [128, 76],
    [128, 77],
    [124, 95],
    [113, 114],
    [110, 119],
    [103, 121],
    [94, 122],
    [83, 122],
    [49, 117],
    [20, 110],
    [16, 109],
    [13, 108],
    [11, 107],
    [7, 102]
  ]
}
